import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const DEFAULT_ROUTE = '/drivers';
export const routes = [DEFAULT_ROUTE];

const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!routes.includes(pathname)) {
            navigate(DEFAULT_ROUTE);
        }
    }, [pathname, navigate]);

    return null;
};

export default DefaultRedirect;
